(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    // IT: the header takes its colour from the slide showing under it (block setting it_header_tone).
  document.addEventListener('slideshow:select', (event) => {
    const header = document.getElementById('header-component');
    const hero = document.querySelector('.content-for-layout > .shopify-section:first-child');
    if (!header || !(event.target instanceof Node) || !hero?.contains(event.target)) return;
    header.dataset.slideTone = event.detail?.slide?.dataset.headerTone || '';
  });
  } catch(e) { console.error(e); }
})();

})();
